<header class="help-panel__header">
  @if (history().length) {
    @let backLabel = "BACK" | translate | capitalize;
    <button type="button" class="help-panel__button" [title]="backLabel" [attr.aria-label]="backLabel" (click)="back()">
      <i class="rc-icon-arrow-left"></i>
    </button>
  }
  <h2 class="help-panel__title">
    <i class="rc-icon-help"></i>
    {{ "HELP" | translate | capitalize }}
  </h2>
  @if (topics().length && current() !== null) {
    @let topicsLabel = "HELP_TOPICS" | translate | capitalize;
    <button
      type="button"
      class="help-panel__button"
      [title]="topicsLabel"
      [attr.aria-label]="topicsLabel"
      (click)="open(null)">
      <i class="rc-icon-list"></i>
    </button>
  }
  @let closeLabel = "CLOSE" | translate | capitalize;
  <button
    type="button"
    class="help-panel__button"
    [title]="closeLabel + ' (Esc)'"
    [attr.aria-label]="closeLabel"
    (click)="closed.emit()">
    <i class="rc-icon-times"></i>
  </button>
</header>

<div #body class="help-panel__body">
  @if (current() === null) {
    <nav class="help-panel__topics">
      <h3>{{ "HELP_TOPICS" | translate | capitalize }}</h3>
      <ul>
        @for (topic of topicsWithSections(); track topic.article) {
          <li>
            @if (topic.sections.length) {
              <!-- The sections fold open; those of the manual of the current screen are open -->
              <details class="help-panel__topic" [open]="topic.article === screenFile()">
                <summary>
                  <a href="" (click)="$event.preventDefault(); open(topic.article)">{{ topic.title }}</a>
                </summary>
                <ul class="help-panel__sections">
                  @for (section of topic.sections; track section.id) {
                    <li>
                      <a href="" (click)="$event.preventDefault(); open(topic.article + '#' + section.id)">{{
                        section.title
                      }}</a>
                    </li>
                  }
                </ul>
              </details>
            } @else {
              <a class="help-panel__topic" href="" (click)="$event.preventDefault(); open(topic.article)">{{
                topic.title
              }}</a>
            }
          </li>
        }
      </ul>
    </nav>
  } @else if (html(); as html) {
    <article class="help-panel__article" [innerHTML]="html" (click)="onArticleClick($event)"></article>
  } @else if (hasError()) {
    <p class="help-panel__message">{{ "HELP_NOT_FOUND" | translate | capitalize }}</p>
  } @else if (isLoading()) {
    <div class="help-panel__message"><rc-crown-loader [color]="'primary'" [size]="'lg'" /></div>
  }
</div>
